export const defaultChoiceDisplayConfig = 'Click to write Choice';
